export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=org.coupling.wallet';

export const APP_STORE_URL = 'https://apps.apple.com/app/coupling-org/id6759029552';

/** True once APP_STORE_URL contains a real numeric app ID */
export const APP_STORE_URL_READY = /\/id\d+/.test(APP_STORE_URL);
